import { useState } from "react";
import styles from "./refinanceCalculator.module.css";
import RefinanceCalculatorResult from "./refinanceCalculatorResult";
import CurrencyInput from "react-currency-input-field";

const RefinanceCalculator = () => {
  const [loan, setLoan] = useState(500000);
  const [year, setYear] = useState(30);
  const [rate, setRate] = useState(6.7);
  const [newRate, setNewRate] = useState(5.84);

  // should refinance be 10-30 years?
  const years = Array.from({ length: 30 }, (_, index) => index + 1);

  const onRCChange = () => {
    setTimeout(() => {
      const tyear = document.getElementById("rcYears").value;
      const trate = document.getElementById("rcRate").value;
      const tnewRate = document.getElementById("rcNewRate").value;
      setYear(tyear);
      setRate(trate);
      setNewRate(tnewRate);
    }, 1000);
  };

  const onLoanChange = (value) => {
    setLoan(value);
  };

  return (
    <>
      <div className={`row ${styles.main_wrapper}`}>
        <div className={`row g-3 ${styles.data_wrapper}`}>
          <div className="col-m-6">
            <label className={`form-label ${styles.label}`}>Loan Amount</label>
            <div className={styles.flex_wrapper}>
              <span className={styles.labeld}>$</span>
              <CurrencyInput
                className={`form-control ${styles.money_input}`}
                id="rcloanAmmount"
                name="input-name"
                defaultValue={loan}
                decimalsLimit={2}
                onValueChange={(value, name, values) => onLoanChange(value)}
              />
            </div>
          </div>
          <div className="col-m-6">
            <label className={`form-label ${styles.label}`}>Loan Term</label>
            <select id="rcYears" onChange={onRCChange} className="form-select">
              {years
                .sort((a, b) => b - a)
                .map((value, index) => (
                  <option key={value} value={value}>
                    {value + ` years`}
                  </option>
                ))}
            </select>
          </div>
          <div className={`col-m-6 ${styles.rate_wrapper}`}>
            <div className={styles.current_rate}>
              <label className={`form-label ${styles.label}`}>
                Current Rate
              </label>
              <div className={styles.flex_wrapper}>
                <input
                  id="rcRate"
                  type="number"
                  step={0.01}
                  min={0}
                  onChange={onRCChange}
                  className={`form-control ${styles.rate_holder}`}
                  defaultValue={rate}
                ></input>
                <span className={styles.labeld3}>%</span>
              </div>
            </div>
            <div className={styles.new_rate}>
              <label className={`form-label ${styles.label}`}>New Rate</label>
              <div className={styles.flex_wrapper}>
                <input
                  id="rcNewRate"
                  type="number"
                  step={0.01}
                  min={0}
                  onChange={onRCChange}
                  className={`form-control ${styles.rate_holder}`}
                  defaultValue={newRate}
                ></input>
                <span className={styles.labeld3}>%</span>
              </div>
            </div>
          </div>
        </div>
        <div className={`row g-3 ${styles.data_wrapper}`}>
          <RefinanceCalculatorResult
            loan={loan}
            year={year}
            rate={rate}
            newRate={newRate}
            newYear={year}
          />
        </div>
      </div>
    </>
  );
};

export default RefinanceCalculator;
